export class ApplicationSearchConstants {
    static FORM_CONTROLS = {
        nameLabel: "Name",
        surnameLabel: "Surname",
        contactNameLabel: "Contact Name",
        contactSurnameLabel: "Contact Surname",
        organisationLabel: "Organisation",
        dateOfBirthLabel: "Date of Birth",
        assignedToLabel: "Assigned to",
        townplannerLabel: "Townplanner",
        transferAttorneyLabel: "Transfer Attorney",
        idNumberLabel: "ID Number",
        dateOfDeathLabel: "Date of death",
        fromDateLabel: "Select 'from' date",
        toDateLabel: "Select 'to' date",
        beforeDateLabel: "Date of deed transfer before",
        afterDateLabel: "Date of deed transfer after",
        percentCompleteLabel: "Percentage complete",
        statusLabel: "Application status",
        erfNoLabel: "Erf No.",
        farmNoLabel: "Farm No.",
        allotmentLabel: "Allotment",
        sgCodeLabel: "SG Code",
        timeoutStatusLabel: "Timeout status",
        applicationTypeLabel: "Application types",
        daysUntilExpiredLabel: "Days until expired",
        dateLabel: "Select date",
        datePlaceholder: "yyyy/mm/dd",
        endDateLabel: "Lease end date",
        startDateLabel: "Lease start date",
        searchText: "Search",
        cancelBtnPlaceholder: "Cancel",
        assignedToUsersForm: "assignedToUsersForm",
        applicantAgentForm: "applicantAgentForm",
        nameFormControl: "nameFormControl",
        surnameFormControl: "surnameFormControl",
        idNumberFormControl: "idNumberFormControl",
        organisationFormControl: "organisationFormControl",
        erfNoFormControl: "erfNoFormControl",
        farmNoFormControl: "farmNoFormControl",
        allotmentFormControl: "allotmentFormControl",
        sgCodeFormControl: "sgCodeFormControl",
        assignedToUsersFormControl: "assignedToUsersFormControl",
        createdDateFormControl: "createdDateFormControl",
        toCreatedDateFormControl: "toCreatedDateFormControl",
        fromCreatedDateFormControl: "fromCreatedDateFormControl",
        dateOfDeathFormControl: "dateOfDeathFormControl",
        statusFormControl: "statusFormControl",
        daysUntilExpiredFormControl: "daysUntilExpiredFormControl",
        applicationTypeFormControl: "applicationTypeFormControl",
        townPlannerFormControl: "townPlannerFormControl",
        groupNameFormControl: "groupNameFormControl",
        deedTransferBeforeDateFormControl: "deedTransferBeforeDateFormControl",
        deedTransferAfterDateFormControl: "deedTransferAfterDateFormControl",
        deedTransferDateFormControl: "deedTransferDateFormControl",
        leaseContractDateFormControl: "leaseContractDateFormControl",
        leaseEndDateFormControl: "leaseEndDateFormControl",
        leaseStartDateFormControl: "leaseStartDateFormControl"
    };
    static APP_EXPAND_PORTAL_APP_A = "point,polygon,applicant,personResponsible,attachments,notes";
    static APP_EXPAND_PORTAL_APP_PL = "properties($expand=owners($expand=groups)),leaseAreas,attachments,applicant,notes";
    static APP_EXPAND_PORTAL_APP_BP = "properties($expand=owners($expand=groups),zonings,buildings),architect,engineer,electricalContractor,notes";
    static APP_EXPAND_PORTAL_APP_BPI = "properties($expand=owners($expand=groups))";
    static APP_EXPAND_PORTAL_APP_BL = "properties, BusinessOwner($expand=groups),applicant($expand=groups),status,applicantAgent($expand=groups),attachments,notes";
    static APP_EXPAND_PORTAL_APP_W = "applicationPolygons,applicationLines,applicationServices,implementingAgent,engineer,contractor,attachments,notes";
    static APP_EXPAND_PORTAL_APP_TP = "applicationTypes,applicationZonings,properties($expand=owners($expand=groups),zonings),notes";
    static APP_EXPAND_PORTAL_APP_GTIA = "applicationTypes,properties($expand=owners($expand=groups),zonings),notes";
    static APP_SEARCH_EXPAND_FULL_LIST_IT = "lastEditedUser,createdSystemUser,applicant,status,applicantAgent,bays,traders($expand=groups),tradeGoods,notes";
    static APP_SEARCH_EXPAND_FULL_LIST_SN = "lastEditedUser,createdSystemUser,applicant,status,applicantAgent,notes";
    static APP_EXPAND_PORTAL_APP_CM = "deceased($expand=deceasedNames), applicantAgent, applicant, funeralParlour, family($expand=groups), attachments,notes";
    static APP_SEARCH_EXPAND_FULL_LIST_DM = "applicant,applicantAgent,properties($expand=owners), attachments,notes";
    static APP_SEARCH_EXPAND_FULL_LIST_RC = "applicant($expand=groups),applicantAgent($expand=groups),transferor($expand=groups),transferee($expand=groups),conveyancer($expand=groups),properties($expand=managingAgent($expand=groups)),attachments,notes";
    static APP_SEARCH_EXPAND_FULL_LIST_EC = "electricalContractor($expand=groups),engineer($expand=groups),applicant($expand=groups),applicantAgent($expand=groups),properties($expand=owners($expand=groups)), attachments,notes";
    static APP_SEARCH_EXPAND_FULL_LIST_TM = "applicant,applicantAgent,properties($expand=owners), attachments,notes";
    static APP_SEARCH_EXPAND_FULL_LIST_ZC = "applicant,applicantAgent,properties($expand=owners), attachments,notes";
    static APPLICATION_AGENT = "applicantAgent";
    static FUNERAL_PARLOUR = "funeralParlour";
    static FAMILY = "family";
    static ORGANISATION = "organisation";
    static APPLICANT = "applicant";
    static STATUS = "status";
    static NAME = "name";
    static SURNAME = "surname";
    static USER_ID = "userId";
    static MODULE_ID = "moduleId";
    static USER = "user";
    static LAST_NAME = "lastName";
    static FIRST_NAME = "firstName";
    static CREATED_DATE = "createdDate";
    static DEFAULT_SEARCH = "referenceNumber";
    static PERCENT_COMPLETE = "percentageComplete";
    static APPLICATION_JOB_LINK = "applicationJobLink";
    static WORKFLOW_SECTION = "WorkflowSection";
    static DAYS_UNTIL_EXPIRED = "daysUntilExpired";
    static TIMEOUT_STATUS = "timeoutStatus";
    static APPLICATION_TYPES = "applicationTypes";
    static APPLICATION_TYPE = "applicationType";
    static OWNERS = "owners";
    static PROPERTIES = "properties";
    static PROPERTY_BUILDINGS = "propertybuildings";
    static PROPERTY_ZONINGS = "propertyzonings";
    static ZONINGS = "zonings";
    static BUILDINGS = "buildings";
    static TOWNPLANNER_ID = "TownplannerId";
    static DECEASED = "deceased";
    static DECEASED_NAMES = "deceasedNames";
    static BURIAL_ORDER_NUMBER = "burialOrderNumber";
    static ID_NUMBER = "idNumber";
    static DATE_OF_BIRTH = "dateOfBirth";
    static DATE_OF_DEATH = "dateOfDeath";
    static OPTION_SELECT_GRAVE = "Search burial applications with grave";
    static GRAVES = "graves";
    static ERF_NUMBER = "erfNumber";
    static FARM_NUMBER = "farmNumber";
    static ALLOTMENT = "allotment";
    static SG_CODE = "sgCode";
    static SEARCH_BY_SHAPE = "SearchByShape";
    static TRANSFER_ATTORNEY = "transferAttorney";
    static BUYERS = "buyers";
    static SELLERS = "sellers";
    static LESSEES = "lessees";
    static DATE_DEED_TRANSFER = "dateOfDeedTransfer";
    static LEASE_START_DATE = "leaseStartDate";
    static LEASE_END_DATE = "leaseEndDate";
    static WITH_GRAVE = "withGrave";
}
